import React from "react";
import { connect } from "react-redux";

// Components
import Searchbar from "../../utils/searchbar/Searchbar";
import SearchTrainingVideoSurveys from "./SearchTrainingVideoSurveys";

// State
import { addRoute } from "../../../store/actions/route";

class AdminTrainingVideoSurveys extends React.Component {
	constructor(props) {
		super(props);

		this.props.addRoute(this.props.match);
	}

	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search training video surveys"}
					component={SearchTrainingVideoSurveys}
					searchEndpoint={"search/training-video-surveys"}
					basePath={null}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminTrainingVideoSurveys);



// WEBPACK FOOTER //
// ./src/components/admin/training-video-surveys/AdminTrainingVideoSurveys.js